export default "__VITE_ASSET__DHCO1Tq___"